<template>
  <ReviewForm :existing-review="review" :title="title" @close="closeModal" />
</template>

<script setup>
import { computed } from 'vue'
import { useStoreTMDB } from '@/stores/storeTMDB'
import ReviewForm from '@/components/ReviewForm'

const props = defineProps({
  review: Object
})
const storeTMDB = useStoreTMDB()
const emit = defineEmits(['close'])

const closeModal = () => {
  emit('close')
}

const title = computed(() => {
  if (!props.review?.tmdb_id || !props.review?.tmdb_type) {
    return null
  }
  return storeTMDB.getTitleById(props.review.tmdb_id, props.review.tmdb_type)
})
</script>
